import styled from 'styled-components';

export const ReportTypesGrid = styled.div`
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    gap: 10px;
`;

export const ReportTypeColumn = styled.div`
    min-width: 0;
`;

export const SectionDivider = styled.div`
    border: 1px solid #ddd;
    margin: 10px 0;
    height: 1px;
`;

export const OutputActionLabel = styled.label<{ disabled?: boolean }>`
    display: flex;
    align-items: center;
    cursor: ${({ disabled }) => (disabled ? 'not-allowed' : 'pointer')};
    opacity: ${({ disabled }) => (disabled ? 0.5 : 1)};
`;

export const OutputActionsContainer = styled.div`
    display: flex;
    gap: 15px;
    justify-content: flex-end;
`;

export const RadioInput = styled.input<{ disabled?: boolean }>`
    margin-right: 5px;
    cursor: ${({ disabled }) => (disabled ? 'not-allowed' : 'pointer')};
`;

export const SelectedCharterersList = styled.div`
    margin-top: 5px;
`;
